import React from 'react';
import Hero from '../components/Hero';
import FeaturekeySection from '../components/FeaturekeySection';
import Benefits from '../components/Benefits';
import PricingSection from '../components/PricingSection';
import FAQ from '../components/FAQ';
import { useNavigate } from 'react-router-dom';



const PayrollPage = () => {
  const navigate = useNavigate();
  return (
    <>
    <Hero
      title="Effortless Global Payroll Solutions for a Smarter Workforce!"
      description="Streamline Your Global Payroll Operations with Seamless Compliance, Accurate Payments, and End-to-End Efficiency for Your Growing Workforce"
      buttonText="Explore More"
      customClass = "secondBanner"
      buttonBgColor="hero-button-bg-color"
      imageSrc="images/payroll.webp"
      squareColor="square-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    <div className="payroll-page">
     <FeaturekeySection/>
      <Benefits/>
{/* 
      <section id="how-it-works">
        <h2>How It Works</h2>
        <ol>
          <li>Onboarding: Gather employee/contractor information.</li>
          <li>Setup: Configure payroll systems for compliance.</li>
          <li>Processing: Automate payroll calculations and payments.</li>
          <li>Compliance Checks: Verify adherence to tax and labor laws.</li>
          <li>Reporting: Generate and review detailed payroll reports.</li>
        </ol>
      </section> */}

     {/*  <section id="testimonials">
        <h2>Client Testimonials</h2>
        <div className="testimonial">
          <p>"XYZ Corp expanded into 5 countries with your payroll system, achieving 100% compliance and reducing payroll processing time by 50%."</p>
        </div>
      </section> */}

      <PricingSection/>
      <FAQ/>
      

      {/* 

      <section id="cta">
        <button>Contact Us for a Quote</button>
        <button>Request a Demo</button>
      </section>

      <section id="resources">
        <h2>Resources/Insights</h2>
        <ul>
          <li>Common Payroll Challenges and How to Solve Them</li>
          <li>Understanding Global Payroll Compliance: A Guide for Businesses</li>
        </ul>
      </section> */}
    </div>
    </>
  );

};

export default PayrollPage;
